import React from "react";
import { Button, ButtonGroup, Dropdown, DropdownButton, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";
import { Awesome, OrderingHeader, YesNoColumn } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function MarketBukaScreen() {
    return (
        <DefaultLayout>
            <List />
        </DefaultLayout>
    );
}

function List() {
    const { t } = useTranslation();
    const { apiData, setApiData, apiUrl } = useAppApi(url_reverse("api:market:buka:list"));
    const { api_post } = useRequest();

    if (!apiData) return;

    const doMultiAction = (ev, buka_ids) => {
        api_post(ev, apiUrl, {
            params: { action: ev.target.name, buka_ids },
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                }
            },
        });
    };

    const createGame = (ev, buka_id) => {
        api_post(ev, apiUrl, {
            params: { action: ev.currentTarget.name, buka_id },
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                }
            },
        });
    };

    const fullImport = (ev) => {
        api_post(ev, apiUrl, {
            params: { action: "update_catalog_full" },
            then: () => alert("Запущен"),
        });
    };

    const header = (
        <>
            {t("Каталог Бука")} <small>({apiData.pager?.count})</small>
        </>
    );

    const headerTools = (
        <>
            <Button href="#" variant="dark" size="sm" onClick={fullImport}>
                {t("Запустить полный импорт")}
            </Button>{" "}
            <DropdownButton as={ButtonGroup} size="sm" variant="dark" title={t("С выбранными")}>
                <Dropdown.Item
                    name="update"
                    onClick={(ev) => {
                        const buka_ids = apiData.object_list.filter((o) => o.chosen).map((o) => o.buka_id);
                        if (buka_ids.length) {
                            doMultiAction(ev, buka_ids);
                        }
                    }}
                >
                    {t("Обновить")}
                </Dropdown.Item>
                <Dropdown.Item
                    name="publish"
                    onClick={(ev) => {
                        const buka_ids = apiData.object_list.filter((o) => o.chosen).map((o) => o.buka_id);
                        if (buka_ids.length) {
                            doMultiAction(ev, buka_ids);
                        }
                    }}
                >
                    {t("Опубликовать")}
                </Dropdown.Item>
                <Dropdown.Item
                    name="unpublish"
                    onClick={(ev) => {
                        const buka_ids = apiData.object_list.filter((o) => o.chosen).map((o) => o.buka_id);
                        if (buka_ids.length) {
                            doMultiAction(ev, buka_ids);
                        }
                    }}
                >
                    {t("Снять с публикации")}
                </Dropdown.Item>
                <Dropdown.Item
                    name="to_black_list"
                    onClick={(ev) => {
                        const buka_ids = apiData.object_list.filter((o) => o.chosen).map((o) => o.buka_id);
                        if (buka_ids.length) {
                            doMultiAction(ev, buka_ids);
                        }
                    }}
                >
                    {t("Добавить в черный список")}
                </Dropdown.Item>
                <Dropdown.Item
                    name="from_black_list"
                    onClick={(ev) => {
                        const buka_ids = apiData.object_list.filter((o) => o.chosen).map((o) => o.buka_id);
                        if (buka_ids.length) {
                            doMultiAction(ev, buka_ids);
                        }
                    }}
                >
                    {t("Убрать из черного списка")}
                </Dropdown.Item>
            </DropdownButton>
        </>
    );

    return (
        <ListingCard header={header} headerTools={headerTools}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th style={{ width: "25px" }} />
                        <th>{t("Buka ID")}</th>
                        <th></th>
                        <th>
                            <OrderingHeader title={t("Игра")} attr="name" />
                        </th>
                        <th>
                            <OrderingHeader title={t("Цена")} attr="price_retail" />
                        </th>
                        <th>
                            <OrderingHeader title={t("Цена со скидкой")} attr="price_retail_stock" />
                        </th>
                        <th>
                            <OrderingHeader title={t("Предзаказ")} attr="is_preorder" />
                        </th>
                        <th>
                            <OrderingHeader title={t("Опубликован Бука")} attr="is_published" />
                        </th>
                        <th>{t("Опубликовано на VK Play")}</th>
                        <th>
                            <OrderingHeader title={t("Наличие ключей")} attr="is_available" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((obj, i) => (
                        <tr key={`object_list${i}`} style={{ backgroundColor: obj.is_black_listed ? "#6c757d59" : "" }}>
                            <td>
                                <DevForm.Checkbox
                                    checked={obj.chosen}
                                    onChange={(ev) => {
                                        const newApiData = { ...apiData };
                                        newApiData.object_list.map((o) => {
                                            if (o.id === obj.id) {
                                                o.chosen = ev.target.checked;
                                            }
                                            return o;
                                        });
                                        setApiData(newApiData);
                                    }}
                                />
                            </td>
                            <td>{obj.buka_id}</td>
                            <td>
                                {!obj.__bk_game.id && obj.is_published && (
                                    <DevForm.Button
                                        variant="warning"
                                        size="sm"
                                        name="create_game"
                                        value={obj.buka_id}
                                        onClick={(ev) => createGame(ev, obj.buka_id)}
                                    >
                                        <Awesome type="plus" tooltip={t("Создать")} />
                                    </DevForm.Button>
                                )}
                            </td>
                            <td>
                                {obj.__bk_game.id ? (
                                    <Link to={url_reverse("games:admin", { game_id: obj.__bk_game.id })}>
                                        {obj.name}
                                    </Link>
                                ) : (
                                    obj.name
                                )}
                            </td>
                            <td>{obj.price_retail}</td>
                            <td>{obj.price_retail_stock}</td>
                            <td>
                                <YesNoColumn attr={obj.is_preorder} />
                            </td>
                            <td>
                                <YesNoColumn attr={obj.is_published} />
                            </td>
                            <td>
                                <YesNoColumn attr={obj.__bk_game.catalog_is_published} />
                            </td>
                            <td>
                                <YesNoColumn attr={obj.is_available} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ListingCard>
    );
}
